export default __webpack_public_path__ + "static/marketing_hero-194331d046e6b4a4b3bbd917328308a4.jpg";